// ─── Design Tokens ───────────────────────────────────────────────────────
export const accent       = "#f57669";
export const accentDim    = "rgba(245,118,105,0.12)";
export const accentBorder = "rgba(245,118,105,0.28)";
export const bg           = "#262729";
export const surface      = "#2d2e31";
export const surface2     = "#34363a";
export const border       = "#3c3e42";
export const borderLight  = "#4d5055";
export const textMuted    = "#a8aaae";
export const textDim      = "#9da1a5";
export const warn         = "#e8c97a";
export const danger       = "#e87a7a";

// ─── Pill-Button-Style (gemeinsam fuer Modi-Pills und Aktions-Buttons) ───
export function pillBtn(filled) {
  return {
    padding: "8px 18px", borderRadius: 999, cursor: "pointer",
    background: filled ? accentDim : "transparent",
    color: filled ? accent : textMuted,
    border: `1px solid ${filled ? accentBorder : borderLight}`,
    fontSize: 13, fontFamily: "'Raleway', system-ui, sans-serif",
    textTransform: "capitalize", whiteSpace: "nowrap"
  };
}
